import { ExternalLink } from 'lucide-react';
import { CopyUri } from './CopyUri';

export function XeroSetupHint() {
  return (
    <div className="rounded-md border bg-muted/40 p-3 text-sm space-y-2" data-testid="xero-setup-hint">
      <p className="font-medium">Before you connect: register this Redirect URI on your Xero app</p>
      <ol className="list-decimal pl-5 space-y-1 text-muted-foreground text-xs">
        <li>Open <a href="https://developer.xero.com/app/manage" target="_blank" rel="noreferrer" className="underline inline-flex items-center gap-0.5">developer.xero.com → My Apps <ExternalLink className="h-3 w-3" /></a>, pick your app, then <strong>Configuration</strong>.</li>
        <li>Under <strong>Redirect URIs</strong> add the address below exactly (https, no trailing slash) and press <strong>Save</strong>.</li>
        <li>Come back here and press <strong>Connect Xero</strong>. Repeat for each site address you connect from.</li>
      </ol>
      <CopyUri value={`${window.location.origin}/api/xero/callback`} testId="xero-redirect-uri" />
    </div>
  );
}
